(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('StatFacturationMensuel', StatFacturationMensuel);

    StatFacturationMensuel.$inject = ['$resource', 'DateUtils'];

    function StatFacturationMensuel ($resource, DateUtils) {
        var resourceUrl =  'api/stat-facturation-mensuels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateStart = DateUtils.convertLocalDateFromServer(data.dateStart);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateStart = DateUtils.convertLocalDateToServer(copy.dateStart);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateStart = DateUtils.convertLocalDateToServer(copy.dateStart);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
